import React from 'react';

import {
  Appointment as AppointmentView,
} from './appointment';
import { appointmentSettings, AppointmentSettingsProps } from '../../../../common/appointment-settings';

const AppointmentContainer = ({
  appointments, isLoading, isError,
}: AppointmentSettingsProps): JSX.Element => (
  <AppointmentView
    appointments={appointments}
    isLoading={isLoading}
    isError={isError}
  />
);

export const Appointment = appointmentSettings(AppointmentContainer);
